import { Box } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function DelayTrend({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const lineData = [{
        id: 'Avg Disclosure Delay',
        data: data.map(d => ({ x: d.month, y: d.avg_delay })),
    }];

    return (
        <ChartSection id="delay-trend" title="Is Congress getting better or worse at disclosing on time?" subtitle="Average disclosure delay trend over time (days between trade and public filing)">
            <Box sx={{ height: 300 }}>
                <ResponsiveLine
                    data={lineData}
                    margin={{ top: 20, right: 20, bottom: 60, left: 50 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 0, max: 'auto' }}
                    curve="monotoneX" enablePoints={false} enableGridX={false}
                    colors={[colors.primary]} lineWidth={2}
                    enableArea areaOpacity={0.06}
                    markers={[{ axis: 'y', value: 45, lineStyle: { stroke: colors.error, strokeDasharray: '4 4' }, legend: '45-day STOCK Act deadline', textStyle: { fill: colors.error, fontSize: 10 } }]}
                    axisBottom={{ tickRotation: 45, tickValues: data.filter((_, i) => i % 12 === 0).map(d => d.month) }}
                    axisLeft={{ legend: 'Days', legendPosition: 'middle', legendOffset: -40 }}
                    enableSlices="x"
                    sliceTooltip={({ slice }) => (
                        <ChartTooltip
                            title={String(slice.points[0].data.x)}
                            rows={slice.points.map(p => ({
                                label: 'Avg delay',
                                value: Number(p.data.y).toFixed(1) + ' days',
                                color: p.seriesColor,
                                valueColor: Number(p.data.y) > 45 ? 'error.main' : 'text.primary',
                            }))}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
